/**
   * Calcula el Set de nombres de layers que contienen TEXT/MTEXT en el cadJson.
   * Escanea: top-level entities, blocks, y los layers de INSERTs que referencian blocks con texto.
   * @returns {Set<string>}
   */
export function getTextLayers(cadJson) {
  const set = new Set()
  if (!cadJson) return set

  const topEntities = cadJson.entities || []

  // 1. TEXT/MTEXT en top-level
  for (const e of topEntities) {
    if ((e.type === 'TEXT' || e.type === 'MTEXT') && e.layer) set.add(e.layer)
  }

  // 2. TEXT/MTEXT dentro de blocks
  const blocks = cadJson.blocks || {}
  const blocksWithText = new Set()
  for (const [name, block] of Object.entries(blocks)) {
    const blockEntities = block.entities || block.data?.entities || []
    for (const e of blockEntities) {
      if (e.type === 'TEXT' || e.type === 'MTEXT') {
        blocksWithText.add(name)
        if (e.layer) set.add(e.layer)
      }
    }
  }

  // 3. Layers de los INSERT que referencian un block con texto
  for (const e of topEntities) {
    if (e.type === 'INSERT' && blocksWithText.has(e.name) && e.layer) {
      set.add(e.layer)
    }
  }

  return set
}

/**
 * Decide si un layer del DXF pertenece a la vista seleccionada.
 * Las layers con TEXT/MTEXT siempre son visibles para mantener etiquetas.
 *
 * @param {string} layerName
 * @param {string} viewCode  - 'pilings' | 'structures' | 'modules' | 'panels'
 * @param {Set<string>} textLayers - layers de texto (de getTextLayers)
 */
export function layerBelongsToView(layerName, viewCode, textLayers) {
  if (textLayers?.has(layerName)) return true

  const upper = layerName.toUpperCase()
  switch (viewCode) {
    case 'pilings':    return upper.startsWith('PILINGS_EPC_') || upper.startsWith('AXLES_EPC_')
    case 'modules':    return upper.startsWith('MODULES_EPC_')
    case 'panels':     return upper.startsWith('PANELS_EPC_')
    case 'structures': return !upper.includes('_EPC_')
    default:           return true
  }
}
